import React, {useState} from 'react';
import { createPortal } from 'react-dom';
import { Link, useParams, useHistory } from 'react-router-dom';
import { Col, Row } from 'antd';
import { useDispatch } from 'react-redux';
import ContentHolder from '@iso/components/utility/contentHolder';
import Select, { SelectOption } from '@iso/components/uielements/select';
import Button from '@iso/components/uielements/button';
import Input, { InputGroup } from '@iso/components/uielements/input';
import Box from '@iso/components/utility/box';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import PageTitleBar from '@iso/components/utility/PageTitleBar';
import ProductCategoryPageWrapper, { Fieldset, Label } from './SingleProductCategory.styles';
import notification from '@iso/components/Notification';
import productCategoryActions from '@iso/redux/productsCategory/actions';
import Loader from '@iso/components/utility/loader';

import apiProductCategory from '@iso/services/repository/productCategory';

const { updateProductCategory } = productCategoryActions;

const Option = SelectOption;
export default function EditForm({ productCategoryId: idProp, onSaved, onCancel, inModal = false, footerEl = null } = {}) {
  const dispatch = useDispatch();
  const [load, setLoad] = useState(true);
  const params = useParams();
  // Na janela flutuante o id vem por prop; na rota, por params
  const productCategoryId = idProp !== undefined ? idProp : params.productCategoryId;
  const [productCategory, setProductCategory] = useState([{}]);
  let history = useHistory();

  React.useEffect(() => {
    apiProductCategory
      .getProductCategoryById(productCategoryId)
      .then((response) => {
        if(!response.data.error){
          setProductCategory(response.data)
        } else {
          setProductCategory(prevState => {
            return { ...prevState, situation: 'Ativo'}
          })
        }
        setLoad(false);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }, [productCategoryId]);

  function checkValues(){
    if(!productCategory.name){
      notification('error', 'Preencha o Nome')
      return false;
    }
    if(!productCategory.situation){
      notification('error', 'Preencha a Situação')
      return false;
    }
    return true;
  }

  // Função do botão Salvar
  const handleSubmit = () => {
    const continuar = checkValues(productCategory);
    if(continuar === true){
        ( !(productCategory.error) && typeof productCategory._id !== "undefined" && productCategory._id !== null ) ?
        notification('success', 'Grupo Salvo') :
        notification('success', 'Grupo Criado');
        
      dispatch(updateProductCategory(productCategory));
      if (onSaved) onSaved();
      else history.push('/dashboard/product-category');
    }
  }

    // Ações (rodapé fixo do modal via portal, ou fim da página na rota cheia)
  const actionButtons = (
    <>
{inModal ? (
          <Button color="primary" onClick={onCancel}>
            <span>Cancelar</span>
          </Button>
        ) : (
          <Link to="/dashboard/product-category">
          <Button>
            <span>Cancelar</span>
          </Button>
        </Link>
        )}
        <Button type="primary" onClick={handleSubmit} className="saveBtn">
          <span>Salvar</span>
        </Button>
    </>
  );
  const actionsRender = footerEl ? (
    createPortal(actionButtons, footerEl)
  ) : (
    <div style={{ display: ('flex'), justifyContent: ('flex-end'), gap: 8, padding: '10px 4px 20px' }}>
      {actionButtons}
    </div>
  );
return (load) ? <Loader /> : (
    <LayoutWrapper>
      
      {inModal ? null : (
      
        <PageTitleBar title={`${productCategory._id ? 'Editar' : 'Cadastrar'} Categoria de Produto`} backTo="/dashboard/product-category" />
      
      )}
      {actionsRender}
      <Box style={{ border: 'none', boxShadow: 'none' }}>
        <ProductCategoryPageWrapper className="editView">
          <div className="PageContent">
            <Box className="productTabsBox" style={{ border: 'none', boxShadow: 'none', padding: 0, background: 'transparent' }} title={<div id="forms.ProductCategory.verticalTitle" />}>
              <ContentHolder>
                <InputGroup size="large" style={{ marginBottom: '15px' }}>
                  <Row gutter={24}>
                    <Col flex={15}>
                      <Fieldset>
                        <Label>Nome*</Label>
                        <Input
                          placeholder="Nome"
                          value={productCategory?.name}
                          name="name"
                          onChange={(e) => {setProductCategory(prevState => {
                              return { ...prevState, name: e.target.value }
                            });
                          }}
                          className="BillFormTitle"
                          />
                      </Fieldset>
                    </Col>
                    <Col flex={9}>
                    <Fieldset>
                        <Label>Situação*</Label>
                        <Select
                          placeholder="Situação"
                          value={(typeof(productCategory?.situation) !== 'undefined') ? productCategory?.situation : 'Ativo'}
                          onChange={(e) => {setProductCategory(prevState => {
                              return { ...prevState, situation: e }
                            });
                          }}
                        >
                          <Option key="Ativo" value="Ativo">Ativo</Option>
                          <Option key="Inativo" value="Inativo">Inativo</Option>
                        </Select>
                      </Fieldset>
                    </Col>
                  </Row>
                </InputGroup>
              </ContentHolder>
            </Box>
          </div>
        </ProductCategoryPageWrapper>
      </Box>
    </LayoutWrapper>
  );
}